export default "__VITE_ASSET__EcjMhCOJ__"